import { render, staticRenderFns } from "./LabelHIcon.vue?vue&type=template&id=1fc66c70&"
import script from "./LabelHIcon.vue?vue&type=script&lang=js&"
export * from "./LabelHIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports